<p-avatar [image]="user?.avatar" [label]="displayedLabel"
    [style]="{ 'background-color': user?.avatarLabelColor, color: '#ffffff' }" [size]="size" shape="circle"></p-avatar>
